import axios from "@/axios";

export default {
    clientCreate(payload) {
        return axios.post(`cabinet/admin/client/create`, payload);
    },
    clientResend(payload) {
        return axios.post(`cabinet/admin/client/${payload.id}/resend`, payload);
    },
    clientVerify(payload) {
        return axios.post(`cabinet/admin/client/${payload.id}/verify`, payload);
    },
    masterList(payload) {
        return axios.get(`cabinet/admin/master/list`, payload);
    },
    masterRentsList(payload) {
        return axios.get(`cabinet/admin/master/${payload.id}/rents`, payload);
    },
    masterCreate(payload) {
        return axios.post(`cabinet/admin/master/create`, payload);
    },
    masterVerify(payload) {
        return axios.post(`cabinet/admin/master/${payload.id}/verify`, payload);
    },
    masterResend(payload) {
        return axios.post(`cabinet/admin/master/${payload.id}/resend`, payload);
    },
    workplace:{
        list(payload) {
            return axios.get(`cabinet/admin/workplaces`, payload);
        },
    },
    master: {
        list(payload) {
            return axios.get(`cabinet/admin/master/list`, payload);
        },
        add(id) {
            return axios.post(`cabinet/admin/master/${id}/add`);
        },
        update(id, payload) {
            return axios.put(`cabinet/admin/master/${id}`, payload);
        },
        contract(id, file) {
            return axios.post(`cabinet/admin/master/${id}/contract`, {contract: file});
        },
        authorize(id) {
            return axios.post(`cabinet/admin/master/${id}/authorize`);
        },
        points(id) {
            return axios.get(`cabinet/admin/master/${id}/points`);
        },
        vacation(id, payload) {
            return axios.post(`cabinet/admin/master/${id}/vacation`, payload);
        },
        frozen(id, payload) {
            return axios.post(`cabinet/admin/master/${id}/frozen`, payload);
        },
        unfrozen(id, payload) {
            return axios.post(`cabinet/admin/master/${id}/unfrozen`, payload);
        },
        tariff(id, payload) {
            return axios.post(`cabinet/admin/master/${id}/tariff`, payload);
        },
        tariffs(id, payload) {
            return axios.get(`cabinet/admin/master/${id}/tariffs`, payload);
        }
    },
    analytic: {
        general: {
            info(payload) {
                return axios.get('cabinet/admin/analytics/general', payload);
            },
        },
        master: {
            list(payload) {
                return axios.get('cabinet/admin/analytics/masters', payload);
            },
        },
        specialization: {
            list(payload) {
                return axios.get('cabinet/admin/analytics/specializations', payload);
            },
        },
    },
    specialization: {
        list(payload) {
            return axios.get('cabinet/admin/specializations', payload);
        }
    },
    rent: {
        list(payload) {
            return axios.get('cabinet/admin/rents', payload);
        },
        create(payload) {
            return axios.post('cabinet/admin/rents', payload);
        },
        update(id, payload) {
            return axios.put(`cabinet/admin/rents/${id}`, payload);
        },
        destroy(id, payload) {
            return axios.destroy(`cabinet/admin/rents/${id}`, payload);
        },
        paid(id, payload) {
            return axios.post(`cabinet/admin/rents/${id}/paid`, payload);
        },
        change(id, payload) {
            return axios.patch(`cabinet/admin/rents/${id}`, payload);
        },
        dates(payload) {
            return axios.get('cabinet/admin/rents/dates', payload);
        },
    }
}
